import { SessionStorage } from 'libs/storage/SessionStorage';
const URL_PARAM_TO_FIELD = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_term: 'utmTerm',
    utm_content: 'utmContent',
    gclid: 'gclid',
    fbclid: 'fbclid',
    msclkid: 'msclkid'
};
/**
 * Assistants that send visitors without campaign params, keyed by referrer
 * host. The value is the source recorded on the deal; ChatGPT links already
 * carry utm_source=chatgpt.com, so its hosts map to the same name.
 */
const AI_REFERRER_SOURCES = {
    'chatgpt.com': 'chatgpt.com',
    'chat.openai.com': 'chatgpt.com',
    'perplexity.ai': 'perplexity.ai',
    'claude.ai': 'claude.ai',
    'gemini.google.com': 'gemini.google.com',
    'copilot.microsoft.com': 'copilot.microsoft.com',
    'meta.ai': 'meta.ai'
};
/** utm_medium recorded for a visit attributed from an assistant referrer. */
export const AI_REFERRER_MEDIUM = 'ai';
/**
 * Source of a visit referred by an AI assistant, or null. Google AI Overviews
 * and AI Mode refer as google.com, indistinguishable from organic search.
 */
export function aiReferrerSource(referrer) {
    var _a;
    let host;
    try {
        host = new URL(referrer).hostname.toLowerCase();
    }
    catch (_b) {
        return null;
    }
    return (_a = AI_REFERRER_SOURCES[host.replace(/^www\./, '')]) !== null && _a !== void 0 ? _a : null;
}
/**
 * Campaign attribution of a landing: its URL params, otherwise the AI
 * assistant that referred it.
 */
export function readCampaignAttribution(search, referrer) {
    const params = new URLSearchParams(search);
    const attribution = {};
    for (const [param, field] of Object.entries(URL_PARAM_TO_FIELD)) {
        const value = params.get(param);
        if (value) {
            attribution[field] = value;
        }
    }
    if (Object.keys(attribution).length > 0) {
        return attribution;
    }
    const aiSource = aiReferrerSource(referrer);
    return aiSource
        ? { utmSource: aiSource, utmMedium: AI_REFERRER_MEDIUM }
        : attribution;
}
function storageKey(host) {
    return `campaign-attribution.${host}`;
}
/**
 * Captures utm_ params, gclid, fbclid and msclkid from the landing URL
 * (or the AI assistant that referred it) into sessionStorage, once per tab
 * session. Never overwrites an existing capture, so the visitor's first
 * touch within this session is kept even if they browse to a page without
 * campaign params afterwards.
 */
export function captureCampaignAttribution(host) {
    if (SessionStorage.get(storageKey(host)) != null) {
        return;
    }
    const attribution = readCampaignAttribution(window.location.search, document.referrer);
    if (Object.keys(attribution).length > 0) {
        SessionStorage.set(storageKey(host), attribution);
    }
}
export function loadCampaignAttribution(host) {
    const stored = SessionStorage.get(storageKey(host));
    return stored != null && typeof stored === 'object' ? stored : {};
}
